import React from 'react';
import { CInput } from '@coreui/react';
import Filters from './Filters';

interface ContactSearchProps {
  onQueryChange: (value) => void;
  onFilterChange: (values) => void;
  searchQuery: string;
}

const ContactSearch = (props: ContactSearchProps) => {
  const {
    onQueryChange,
    onFilterChange,
    searchQuery
  } = props;


  return (
    <div className="d-flex p-2">
      <CInput
        className="chat-search-input mr-2"
        type="search"
        id="chat-search"
        name="chat-search"
        placeholder="Search"
        value={searchQuery}
        onChange={onQueryChange}
      />
      <Filters onFilterChange={onFilterChange} />
    </div>
  )
};

export default ContactSearch;
